import { Box, Text, Group, Button, TextInput, Textarea } from '@mantine/core';
import { useForm } from '@mantine/form';
import { modals } from '@mantine/modals';

import { useUpdatePaymentSystem } from '../hooks/use-update-payment-systems';
import { useDeletePaymentSystem } from '../hooks/use-delete-payment-systems';

import type { TPaymentSystem } from '../store/types';

type FormData = {
  name: string;
  data: string;
};

type Props = {
  item: TPaymentSystem;
};

export const PaymentSystem = (props: Props) => {
  const { item } = props;
  const {
    handleEditPaymentSystem,
    isLoading: isUpdateLoading,
  } = useUpdatePaymentSystem();

  const {
    deletePaymentSystem,
    isLoading: isDeleteLoading,
  } = useDeletePaymentSystem();

  const form = useForm<FormData>({
    mode: 'uncontrolled',
    initialValues: {
      name: item.name,
      data: item.data,
    },
    validate: {
      name: (value) => !value ? 'Введите название' : null,
      data: (value) => !value ? 'Введите данные в формате JSON' : null,
    },
  });

  const handleSubmit = (values: FormData) => {
    modals.openConfirmModal({
      title: 'Сохранение настроек',
      centered: true,
      children: (
        <Text size="sm">
          Вы точно хотите сохранить настройки платёжной системы?
        </Text>
      ),
      labels: { confirm: 'Подтвердить', cancel: 'Отмена' },
      confirmProps: { color: 'blue' },
      onConfirm: () => handleEditPaymentSystem({ ...values, systemId: item.id }),
    });
  };

  const openDeleteModal = () => {
    modals.openConfirmModal({
      title: 'Удаление платёжной системы',
      centered: true,
      children: `Вы точно хотите удалить платёжную систему "${item.name}" с ID ${item.id}?`,
      labels: { confirm: 'Удалить', cancel: 'Отмена' },
      confirmProps: { color: 'red' },
      onConfirm: async () => await deletePaymentSystem({ systemId: item.id }),
    });
  };


  return (
    <Box>
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <TextInput
          label="Название"
          withAsterisk
          key={form.key('name')}
          {...form.getInputProps('name')}
        />
        <Textarea
          label="Данные"
          placeholder="JSON format"
          autosize
          withAsterisk
          key={form.key('data')}
          {...form.getInputProps('data')}
        />

        <Group justify="flex-start" mt="30">
          <Button loading={isDeleteLoading} onClick={openDeleteModal} color="red">
            Удалить
          </Button>
          <Button type="submit" loading={isUpdateLoading}>
            Сохранить
          </Button>
        </Group>
      </form>
    </Box>
  );
};
